import {
  Checkbox,
  FormControlLabel,
  InputLabel,
  Select,
} from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import HeaderPage from '~/components/HeaderPage';
import { ApplicationState } from '~/store';
import {
  categoriaRequest,
  personalRequest,
} from '~/store/ducks/VisualizarDadosDosTitulares/actions';
import getValidationErrors from '~/utils/getValidationErrors';
import Categorias from './categorias';
import {
  Container,
  FormControlLGPD,
  SearchButton,
  StyledButton,
  StyledTextField,
} from './styles';

interface FormContact {
  identification_key: string;
}

const VisualizarDadosDosTitulares: React.FC = () => {
  const dispatch = useDispatch();

  const personal = useSelector<ApplicationState, any>(
    state => state.VisualizarDadosDosTitulares,
  );

  const [formErr, setFormErr] = useState<any>({});

  const [form, setForm] = useState<FormContact>({
    identification_key: '',
  });

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const target = event.target;
      const name = target.name;

      setForm({
        ...form,
        [name]: target.value,
      });

      setFormErr({
        ...formErr,
        [name]: false,
      });
    },
    [form, formErr],
  );

  const [ownership, setOwnership] = useState<number | undefined>(0);

  const handleChangeOwnership = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: any;
    }>,
  ) => {
    setOwnership(event.target.value);
    setFormErr({
      ...formErr,
      ownership_type: false,
    });
  };

  const { company } = useSelector<ApplicationState, any>(state => state.auth);

  const getPersonal = useCallback(async () => {
    const config = {
      identification_key: form.identification_key,
      ownership_type: ownership,
      company: company?.country_company_id,
    };

    try {
      const schema = Yup.object().shape({
        identification_key: Yup.string().required('CPF obrigatório!'),
        ownership_type: Yup.string().test(
          'ownership_type',
          'Categoria obrigatório',
          value => {
            return value !== '0' && value !== '' ? true : false;
          },
        ),
      });

      await schema.validate(config, { abortEarly: false });

      dispatch(personalRequest(config));
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const err = getValidationErrors(error);

        toast.error('Necessário o preenchimento dos campos de identificação.');

        setFormErr(err);
      }
    }
  }, [form.identification_key, ownership, company, dispatch]);

  const [print, setPrint] = useState({
    empregado: false,
    dependente: false,
    beneficiario: false,
  });

  const handleChangePrint = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setPrint({ ...print, [event.target.name]: event.target.checked });
    },
    [print],
  );

  const printDocument = () => {
    //@ts-ignore
    document.getElementsByTagName('aside')[0].hidden = true;
    //@ts-ignore
    document.getElementsByTagName('nav')[0].hidden = true;
    //@ts-ignore
    document.querySelector('.content-wrapper > div').style.display = 'none';
    //@ts-ignore
    document.querySelector(
      '#root > div.wrapper > div > section > div > div > div',
      //@ts-ignore
    ).style.display = 'none';

    //@ts-ignore
    document.querySelector(
      '#root > div.wrapper > div > section > div > div.main-content-solicitar-ajuda-dpo > h1',
      //@ts-ignore
    ).style.display = 'none';

    //@ts-ignore
    document.querySelector(
      '#root > div.wrapper > div > section > div > div.main-content-solicitar-ajuda-dpo > div.contact-dpo-left',
      //@ts-ignore
    ).style.display = 'none';

    //@ts-ignore
    document.querySelector('#export-visualizar-dados').style.display = 'none';

    if (personal.data.tipo === 2) {
      //@ts-ignore
      document.querySelector('#select-data-export').style.display = 'none';

      if (!print.beneficiario) {
        //@ts-ignore
        document.querySelector('#dados-beneficiarios').style.display = 'none';
      }
      if (!print.dependente) {
        //@ts-ignore
        document.querySelector('#dados-dependentes').style.display = 'none';
      }
      if (!print.empregado) {
        //@ts-ignore
        document.querySelector('#dados-financeiros').style.display = 'none';
        //@ts-ignore
        document.querySelector('#dados-cadastrais').style.display = 'none';
      }
      if ((!print.dependente || !print.beneficiario) && !print.empregado) {
        //@ts-ignore
        document.querySelector('#add-info-2').style.display = 'none';
        //@ts-ignore
        document.querySelector('#add-info').style.display = 'none';
      }
    }

    //@ts-ignore
    window.print();

    if (personal.data.tipo === 2) {
      //@ts-ignore
      document.querySelector('#select-data-export').style.display = 'block';

      if (!print.beneficiario) {
        //@ts-ignore
        document.querySelector('#dados-beneficiarios').style.display = 'block';
      }
      if (!print.dependente) {
        //@ts-ignore
        document.querySelector('#dados-dependentes').style.display = 'block';
      }
      if (!print.empregado) {
        //@ts-ignore
        document.querySelector('#dados-financeiros').style.display = 'block';
        //@ts-ignore
        document.querySelector('#dados-cadastrais').style.display = 'block';
      }
      if ((!print.dependente || !print.beneficiario) && !print.empregado) {
        //@ts-ignore
        document.querySelector('#add-info-2').style.display = 'block';
        //@ts-ignore
        document.querySelector('#add-info').style.display = 'block';
      }
    }
    //@ts-ignore
    document.getElementsByTagName('aside')[0].hidden = false;
    //@ts-ignore
    document.getElementsByTagName('nav')[0].hidden = false;
    //@ts-ignore
    document.querySelector('.content-wrapper > div').style.display = 'block';
    //@ts-ignore
    document.querySelector(
      '#root > div.wrapper > div > section > div > div > div',
      //@ts-ignore
    ).style.display = 'block';

    //@ts-ignore
    document.querySelector(
      '#root > div.wrapper > div > section > div > div.main-content-solicitar-ajuda-dpo > h1',
      //@ts-ignore
    ).style.display = 'block';

    //@ts-ignore
    document.querySelector(
      '#root > div.wrapper > div > section > div > div.main-content-solicitar-ajuda-dpo > div.contact-dpo-left',
      //@ts-ignore
    ).style.display = 'block';

    //@ts-ignore
    document.querySelector('#export-visualizar-dados').style.display = 'block';
  };

  useEffect(() => {
    dispatch(categoriaRequest(1));
  }, [dispatch]);

  return (
    <Container>
      <HeaderPage pageTitle="Visualizar dados dos titulares" />

      <div className="main-content-solicitar-ajuda-dpo">
        <h1>Insira os dados do titular</h1>

        <div className="contact-dpo-left">
          <InputMask
            mask="999.999.999-99"
            value={form.identification_key}
            onChange={handleChange}
            name="identification_key"
            disabled={false}
            maskChar=""
            children={() => (
              <StyledTextField
                identificationKeyError={
                  !!formErr?.identification_key ? true : false
                }
                name="identification_key"
                id="identificationKey"
                label="CPF do titular"
                variant="outlined"
                className="TextField-lgpd"
              />
            )}
          />

          <FormControlLGPD
            variant="outlined"
            ownershipTypeError={!!formErr?.ownership_type ? true : false}
          >
            <InputLabel htmlFor="outlined-ownershipType-native-simple">
              Categoria
            </InputLabel>
            <Select
              native
              value={ownership}
              onChange={handleChangeOwnership}
              label="Categoria"
              inputProps={{
                name: 'ownershipType',
                id: 'ownershipType',
              }}
            >
              <option aria-label="ownershipType" value="" />
              {personal.categorias.map((el: any) => (
                <option
                  key={el.data_holder_cat_id}
                  value={el.data_holder_cat_id}
                >
                  {el.data_holder_cat_name}
                </option>
              ))}
            </Select>
          </FormControlLGPD>

          <SearchButton onClick={getPersonal}>Pesquisar</SearchButton>
        </div>

        {personal.data.tipo === 2 ? (
          <div className="hiden-select-data" id="select-data-export">
            <p>Selecione as opções para exportação</p>
            <FormControlLabel
              control={
                <Checkbox
                  checked={print.empregado}
                  onChange={handleChangePrint}
                  name="empregado"
                  color="primary"
                />
              }
              label="Empregado"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={print.dependente}
                  onChange={handleChangePrint}
                  name="dependente"
                  color="primary"
                />
              }
              label="Dependente"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={print.beneficiario}
                  onChange={handleChangePrint}
                  name="beneficiario"
                  color="primary"
                />
              }
              label="Beneficiário"
            />
          </div>
        ) : (
          ''
        )}

        <div className="content-categorias">
          <Categorias personalData={personal.data} />
        </div>
      </div>

      <StyledButton
        className="button-continue"
        id="export-visualizar-dados"
        onClick={printDocument}
      >
        Exportar
      </StyledButton>
    </Container>
  );
};

export default VisualizarDadosDosTitulares;
